import type { IButtonCompProps } from '../Basic/PropInterfaces';
import { reactive, unref, type Ref } from 'vue';
import { randomstring } from '@/utilities/utils';
import type { IIcon } from '../Interfaces';

type IButtonProps = {
    [K in keyof IButtonCompProps]: undefined extends IButtonCompProps[K]
        ? IButtonCompProps[K] | Ref<Exclude<IButtonCompProps[K], undefined>> | undefined
        : IButtonCompProps[K] | Ref<IButtonCompProps[K]>;
};

// TODO: This is similar to DropDownItemButton. I think we need to improve the button abit. For example the text and the icon should really be button props
// And this and DropdownItemButton could both be converted to a general "This is a button in code" thing
export class ModalButton<TButtonActionArgs = void, TButtonClickResult = any> {
    public action: (args: TButtonActionArgs) => TButtonClickResult | Promise<TButtonClickResult>;
    public props: IButtonCompProps;
    public loopKey?: string;
    public text: string | Ref<string>;
    public icon?: IIcon['icon'] | Ref<IIcon['iconFamily']>;

    private constructor(
        action: (args: TButtonActionArgs) => TButtonClickResult | Promise<TButtonClickResult>, // Note, this is typed with inputParameters so we can use it in the dialog system. If used in ModalComp directly there wont be any parameters.
        props: IButtonProps,
        text: string | Ref<string>,
    ) {
        this.action = action;
        this.props = reactive(props);
        this.text = text;

        // If we have a text we use that and the icon as the loop key, otherwise we generate a random one
        // Note: This means that if we recreate the button object it will get a new loop key, not the same even tho the objects deep equals otherwise.
        if (text) {
            this.loopKey = `${unref(text)}-${props.icon ? unref(props.icon) : 'noicon'}`;
        } else {
            this.loopKey = randomstring('');
        }
    }

    public static Create<TButtonActionArgs = void, TButtonClickResult = any>(
        params: {
            action: (args: TButtonActionArgs) => TButtonClickResult | Promise<TButtonClickResult>;
            text: string | Ref<string>;
        } & IButtonProps,
    ) {
        const { action, text, ...props } = params;
        return new ModalButton<TButtonActionArgs, TButtonClickResult>(action, props, text);
    }
}
